(function () {
  function initProduct() {
    var root = document.querySelector('[data-sy-product]');
    if (!root || root.dataset.syReady === 'true') return;
    root.dataset.syReady = 'true';
    var select = root.querySelector('[data-sy-variant]');
    var price = root.querySelector('[data-sy-price]');
    var compare = root.querySelector('[data-sy-compare]');
    var unit = root.querySelector('[data-sy-unit]');
    var add = root.querySelector('[data-sy-add]');
    var image = root.querySelector('[data-sy-main-image]');
    var quantity = root.querySelector('#SyQuantity');

    function updateVariant() {
      if (!select) return;
      var option = select.options[select.selectedIndex];
      if (price) price.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.classList.toggle('hidden', !option.dataset.compare);
      }
      if (unit) {
        unit.textContent = option.dataset.unit || '';
        unit.classList.toggle('hidden', !option.dataset.unit);
      }
      if (add) {
        var available = option.dataset.available === 'true';
        add.disabled = !available;
        add.textContent = available ? 'Agregar al carrito' : 'Agotado';
      }
      if (image && option.dataset.image) image.src = option.dataset.image;
      window.history.replaceState({}, '', window.location.pathname + '?variant=' + option.value);
    }

    if (select) select.addEventListener('change', updateVariant);
    root.querySelectorAll('[data-image]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (image && button.dataset.image) image.src = button.dataset.image;
      });
    });
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    if (minus && quantity) minus.addEventListener('click', function () {
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    });
    if (plus && quantity) plus.addEventListener('click', function () {
      quantity.value = Number(quantity.value || 1) + 1;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProduct, { once: true });
  else initProduct();
})();
